import React, {useEffect} from "react";
import Footer from "../../components/Footer";
import Header from "../../components/Header";

function Page({children}) {

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [children]);

    return(
        <>
            <Header/>

            {children}

            <Footer/>
        </>
    )
}

export default Page;